export const defaultCompaniesCountPerPage = 10;
